import React from 'react'
import './styles.scss';
import Element from './Element'

const state = window.__STATE__ || {};
const {publisher} = state.article || { publisher: null };

export default () => (
    <Element publisher={publisher} />
)
